/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.

/*
 * EXPORTS
 */
export default gql`
  query SmsReadFailedQuery(
    $endDate: DateTime!
    $startDate: DateTime!
    $filter: JSONObject
  ) {
    SmsReadFailed(endDate: $endDate, startDate: $startDate, filter: $filter) {
      message
      status
      data {
        error
        status
        _count {
          _all
        }
      }
    }
  }
`;
